module.exports = __webpack_public_path__ + "images/404.1792034611141.png";